import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { renderToString, ParseError } from 'katex';

@Pipe({
  name: 'displayMath',
})
export class DisplayMathPipe implements PipeTransform {
  private readonly domSanitizer: DomSanitizer = inject(DomSanitizer);

  /**
   * Pipe that transform all katex formula in the given string
   */
  //eslint-disable-next-line max-lines-per-function
  public transform(value: string | null): SafeHtml | null {
    if (typeof value !== 'string') {
      return value;
    }
    const regex: RegExp = /<span\s*class="math-tex">([.\s\S]*?)<\/span>/gm;
    const isScript: RegExp = /<script\s*type="math\/tex">[.\s\S]*?<\/script>/gm;

    if (isScript.test(value)) {
      // Script tag is saved instead of span on the MPC question answers. This
      // is a stop-gap to fix the visuals.
      value = value.replace(isScript, (match, _current) => {
        return match
          .replace(/<script\s*type="math\/tex">/gm, '<span class="math-tex">')
          .replace(/<\/script>/gm, '</span>');
      });
    }

    value = value.replace(regex, (match, mathTex) => {
      try {
        // Bug #155 LaTex breaks on backslash escape chars '\(a/b\)'
        // Backslash is used in square root (\sqrt{a})^2 and fractions y=-\frac23x, so we can not strip all of them.
        // Note: re-saving the function in Lyceo Dashboard with backslashes to escape '\(' or '\)' will strip them.
        // So the issue will eventually fix itself. This fix is for existing content.
        mathTex = mathTex.replace(/\\\(/g, '(').replace(/\\\)/g, ')');
        return renderToString(mathTex, {
          displayMode: false,
          errorColor: '#ff0000',
        });
      } catch (e) {
        if (e instanceof ParseError) {
          // KaTeX can't parse the expression
          return `<span style="color: #ff0000">Error in Katex '${mathTex}': ${e.message}</span>`;
        }
        return '<span style="color: #ff0000">Unknown Katex error.</span>';
      }
    }) as string;

    return this.domSanitizer.bypassSecurityTrustHtml(value);
  }
}
